import React, { useRef, useState, useEffect } from "react";
import { FormikProvider, useFormik } from "formik";
import { Link } from "react-router-dom";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import { POST_GetTopMachinesData } from "../../../helpers/url_helper";
import * as echarts from "echarts";

const TopMachines = () => {
  const [isLoading, setIsLoading] = useState(false);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const formik = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      DayType: 1,
      TopMachinesList: [],
      MachineNames: [],
      TestingCounts: [],
      PeriodType: 1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      DayType,
      TopMachinesList,
      MachineNames,
      TestingCounts,
      PeriodType,
    },
  } = formik;

  useEffect(() => {
    getTopMachinesDetails(1);
  }, []);

  const getTopMachinesDetails = async (typeid) => {
    formik.setFieldValue("PeriodType", typeid);
    // getData(typeid);
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      PeriodType: typeid,
    };

    await post(POST_GetTopMachinesData, payload)
      .then((response) => {
        formik.setFieldValue("TopMachinesList", response?.List);
        bindChartData(response?.List);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const bindChartData = (list) => {
    let machineNameArray = [],
      testingCountArray = [];

    Promise.all(
      list?.map((x) => {
        machineNameArray.push(x.MachineName);
        testingCountArray.push(x.TestingCount);
      })
    );

    formik.setFieldValue("MachineNames", machineNameArray);
    formik.setFieldValue("TestingCounts", testingCountArray);
  };

  const chartRef = useRef();

  useEffect(() => {
    const myChart = echarts.init(chartRef.current);

    const option = {
      tooltip: {
        trigger: "item",
        formatter: "{b} <br/>Testing Count : {c}",
      },
      // legend: {
      //   top: "bottom",
      // },
      toolbox: {
        show: true,
        feature: {
          mark: { show: true },
          dataView: { show: false, readOnly: false },
          restore: { show: false },
          saveAsImage: { show: false },
        },
      },
      series: [
        {
          name: "",
          type: "pie",
          radius: [50, 150],
          center: ["50%", "50%"],
          roseType: "area",
          itemStyle: {
            borderRadius: 8,
          },
          data: TopMachinesList.map((item) => ({
            name: item.MachineName + " - " + item.TestingCount,
            value: item.TestingCount,
          })),
          label: {
            color: "inherit",
          },
        },
      ],
      grid: {
        left: 20,
        top: 20,
        right: "5%",
        bottom: "5%",
      },
    };

    myChart.setOption(option);

    // Clean up the chart instance
    return () => {
      myChart.dispose();
    };
  }, [TopMachinesList]);

  return (
    <>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="card mb-1" style={{ height: "calc(100% - 10px)" }}>
          <div className="card-body p-0">
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0 ps-2">Top Machine</h4>
                <FormikProvider value={formik}>
                  <form onSubmit={formik.handleSubmit}>
                    <div className="d-flex align-items-center">
                      <Link
                        title="Current Year"
                        className={`btn ${
                          PeriodType == 1
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopMachinesDetails(1);
                        }}
                      >
                        CY
                      </Link>
                      &nbsp;
                      <Link
                        title="Current Month"
                        className={`btn ${
                          PeriodType == 2
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopMachinesDetails(2);
                        }}
                      >
                        CM
                      </Link>
                      &nbsp;
                      <Link
                        title="Previous Month"
                        className={`btn ${
                          PeriodType == 3
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopMachinesDetails(3);
                        }}
                      >
                        PM
                      </Link>
                    </div>
                  </form>
                </FormikProvider>
              </div>
              <div>
                <div
                  ref={chartRef}
                  style={{ width: "100%", height: "400px" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </>
  );
};

export default TopMachines;
